import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CrudConfig, RequestParams} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {throughputType} from '@brands-compart/form-wizard';
import {DatagridService} from './datagrid.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Component({
  selector: 'app-datagrid-search',
  templateUrl: './datagrid-search.component.html'
})
export class DatagridSearchComponent implements OnInit, AfterViewInit {
  @Input() searchEnabled: boolean;

  public throughputTypeChunks = [];
  public initialized: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private usedThroughputFilterIds = [];
  private bConfigured: boolean = false;
  private throughputTypeFilterGroupId = this.crudConfig.getGroupId();
  private dateFromFilterId = this.crudConfig.getFilterId();
  private dateTillFilterId = this.crudConfig.getFilterId();
  private channelNumberFilterId = this.crudConfig.getFilterId();

  private usedChannelFilterIds = [];

  public config = {
    filters: {
      owner:              {enabled: false, value: '', options: []},
      customer:           {enabled: false, value: '', options: []},
      building:           {enabled: false, value: '', options: [], onSelect: null},
      floor:              {enabled: false, value: '', options: [], onSelect: null},
      room:               {enabled: false, value: '', options: []},
      mechanic:           {enabled: false, value: '', options: []},
      warrantyStatus:     {enabled: false, value: '', options: []},
      channelStatus:      {enabled: false, value: '', options: ['TERMINATED']},
      channelNumbers:     {enabled: false, value: ''},
      location:           {enabled: false, value: '', options: []},
      remarks:            {enabled: false, value: ''},
      dateFrom:           {enabled: false, value: ''},
      dateTill:           {enabled: false, value: ''},
      throughputType:     {enabled: false, value: '', options: []},
      maintenance:        {enabled: false, value: ''},
      assignment:         {enabled: false, value: ''}
    }
  };

  @Output()
  private onDoFilter = new EventEmitter<any>();

  @Input()
  public requestParams: RequestParams;

  constructor(
    private crudConfig: CrudConfig,
    private dategridService: DatagridService,
    private router: UIRouter,
  ) {}

  ngOnInit() {
    const throughputTypesAsArray = [];
    const throughputTypeKeys = Object.keys(throughputType);
    for(let i = 0; i < throughputTypeKeys.length; i++) {
      throughputTypesAsArray.push({
        key: throughputTypeKeys[i],
        value: throughputType[throughputTypeKeys[i]],
        checked: false,
      });
    }

    const chunks = 4;
    const itemsPerChunk = Math.ceil(throughputTypeKeys.length / chunks);
    const numberOfTypes = throughputTypesAsArray.length;

    for(let j = 0; j < numberOfTypes; j += itemsPerChunk) {
      this.throughputTypeChunks.push(throughputTypesAsArray.splice(0, itemsPerChunk));
    }

    for (const filterType in this.router.stateService.params) {
      if (typeof this.config.filters[filterType] !== 'undefined') {
        this.config.filters[filterType].value = this.router.stateService.params[filterType];
      }
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initialized.next(true);
    }, 0);
  }

  public doFilter(event) {
    this.onDoFilter.emit();
  }

  public setConfigured() {
    this.bConfigured = true;
  }

  public getConfigured() {
    return this.bConfigured;
  }

  public onFilterChange(filterType) {
    if(typeof this.config.filters[filterType].onSelect === 'function') {
      this.config.filters[filterType].onSelect();
    }
  }

  public dateFromChange() {
    setTimeout(() => {
      this.dateChange('FROM', this.config.filters.dateFrom.value);
    }, 0);
  }

  public dateTillChange() {
    setTimeout(() => {
      this.dateChange('TILL', this.config.filters.dateTill.value);
    }, 0);
  }

  private dateChange(type: string, value: string) {
    const operator = (type === 'FROM') ? 'ge' : 'le';
    const id = (type === 'FROM') ? this.dateFromFilterId : this.dateTillFilterId;

    if(value) {
      const date = new Date(value);
      const dateString = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).substr(-2)}-${('0' + date.getDate()).substr(-2)}`;

      this.requestParams.addFilterParam({
        id: id,
        key: 'registrationDate',
        operator: operator,
        value: dateString,
      });
    } else {
      this.requestParams.removeFilterParam(id);
    }
  }

  public channelNumbersChange(event) {
    this.requestParams.addFilterParam({
      id: this.channelNumberFilterId,
      key: 'channelNumbers',
      operator: 'eq',
      value: (event.target as HTMLInputElement).value,
    });
  }

  public throughputTypeChange() {

    this.usedThroughputFilterIds.forEach((filterId) => {
      this.requestParams.removeFilterParam(filterId);
    });

    this.usedThroughputFilterIds.splice(0, this.usedThroughputFilterIds.length);

    let isFirst = true;
    this.throughputTypeChunks.forEach((chunk) => {
      chunk.forEach((throughputType) => {
        if(throughputType.checked) {
          const filterId = this.crudConfig.getFilterId();
          this.usedThroughputFilterIds.push(filterId);

          const filterParam: any = {
            id: filterId,
            groupId: this.throughputTypeFilterGroupId,
            key: 'throughputs.type',
            operator: 'eq',
            value: throughputType.value
          };

          if(!isFirst) {
            filterParam.joinOperator = 'or';
          }

          this.requestParams.addFilterParam(filterParam);

          if(isFirst) {
            isFirst = false;
          }
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/datagrid/datagrid-search.component.ts